import { render, staticRenderFns } from "./ManageHoliday.vue?vue&type=template&id=4aa738c4&scoped=true"
import script from "./ManageHoliday.vue?vue&type=script&lang=js"
export * from "./ManageHoliday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa738c4",
  null
  
)

export default component.exports